export default "__VITE_ASSET__CieKi$9b__"